import { createSlice } from '@reduxjs/toolkit';

export const environmentSlice = createSlice({
  name: 'environment',
  initialState: process.env.NODE_ENV,
});

export const getEnvironment = state => state[environmentSlice.name];
